import moment from 'moment';
import { FirebaseConfig, FirebaseCourseItem } from '../types/types';

export const isShortlyBeforeCourse = (
  course: FirebaseCourseItem,
  config: FirebaseConfig
) =>
  moment().isBefore(course.endMoment, 'minutes') &&
  moment().diff(course.startMoment, 'minutes') >
    -config.courseJoinBeforeDuration;
